import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-youth-ranking-classif',
    templateUrl: './youth-ranking-classif.component.html',
    styleUrls: ['./youth-ranking-classif.component.scss'],
})
export class YouthRankingClassifComponent implements OnInit {
    /**
     * Definição para receber o identificador do ranking
     */
    rankingId: string;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.rankingId = this.route.snapshot.paramMap.get('rankingId');
        //console.log('youth-ranking-classif= ' + this.rankingId);
    }
}
